import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import CameraIcon from '@material-ui/icons/PhotoCamera';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import Copyright from '../components/Copyright'
import ApartmentCard from '../components/ApartmentCard'

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}));


export default function Album() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <CssBaseline />
      <main>
        {/* Hero unit */}
        <div className={classes.heroContent}>
          <Container maxWidth="sm">
            <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
              Connecticut Apartments for Rent
            </Typography>
            <Typography variant="h5" align="center" color="textSecondary" paragraph>
              WE ACCEPT SECTION 8. Below are apartments that we have available. Apply today.
            </Typography>
          </Container>
        </div>
        <Container className={classes.cardGrid} maxWidth="md">
          {/* End hero unit */}
          <Grid container spacing={4}>
              <Grid item key={1} xs={12} sm={6} md={4}>
                <ApartmentCard
                    town="Hartford" 
                    bedroomcount="1"
                    bathcount="1"
                    address="353 Capitol Avenue, Unit C3, Hartford, CT"
                    floor="3rd"
                    rent="$800.00"
                    image1url="https://s3.amazonaws.com/media.constitutionmgmt.com/353Capitol/353CapitolAve1.jpeg"
                    image2url="https://s3.amazonaws.com/media.constitutionmgmt.com/353Capitol/353CapitolAve2.jpeg"
                    />
              </Grid>
              <Grid item key={1} xs={12} sm={6} md={4}>
                <ApartmentCard
                    town="Hartford" 
                    bedroomcount="2"
                    bathcount="1"
                    address="353 Capitol Avenue, Unit C2, Hartford, CT"
                    floor="3rd"
                    rent="$1,075.00"
                    image1url="https://s3.amazonaws.com/media.constitutionmgmt.com/353Capitol/353CapitolAve3.jpeg"
                    image2url="https://s3.amazonaws.com/media.constitutionmgmt.com/353Capitol/353CapitolAve4.jpeg"
                    />
              </Grid>
          </Grid>
        </Container>
      </main>
      {/* Footer */}
      <footer className={classes.footer}>
        <Copyright />
      </footer>
      {/* End footer */}
    </React.Fragment>
  );
}